import { Inject, Injectable } from '@angular/core';
import { WINDOW } from './window-provider';

@Injectable({
  providedIn: 'root'
})
export class WindowParentService {
  constructor(@Inject(WINDOW) private window: Window) {}

  private originHost: string = '';

  insideIframe(): boolean {
    return this.window.location !== this.window.parent.location;
  }

  init(): void {
    const referrer = this.window.document.referrer;
    this.originHost = this.insideIframe() ? this.getHostnameForUrl(referrer) : '';
  }

  private getHostnameForUrl(url: string): string {
    const a = this.window.document.createElement('a');
    a.href = url;
    return `${a.protocol}//${a.host}`;
  }

  isOriginHost(expectedHost: string): boolean {
    return this.originHost === expectedHost;
  }

  postMessage<T>(message: T): void {
    this.window.parent.postMessage(message, this.originHost);
  }

  getHostUrl(hostRelativeRef: string): string {
    return this.originHost + hostRelativeRef;
  }

  getHostDomain(): string {
    const originHostParts = this.originHost.split('.');
    const length = originHostParts.length;
    if (length > 1) {
      const domainStartParts = originHostParts[length - 2].split('/');
      return domainStartParts[domainStartParts.length - 1] + '.' + originHostParts[length - 1];
    }
    const localHostIndex = this.originHost.indexOf('localhost');
    return localHostIndex < 0 ? '' : this.originHost.substring(localHostIndex);
  }
}
